import { QuoteButton } from '@/components/common/QuoteButton';
import { useEffect, useRef } from "react";
export default function CompositeDeckingFeature() {
  const sectionRef = useRef<HTMLElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && contentRef.current) {
          contentRef.current.classList.remove("opacity-0", "translate-y-8");
          contentRef.current.classList.add("opacity-100", "translate-y-0");
        }
      });
    }, {
      threshold: 0.2
    });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);
  return <section ref={sectionRef} className="dark bg-black text-foreground w-full overflow-hidden">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;1,400&family=Space+Grotesk:wght@300;400;500&display=swap');`}</style>

      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[85vh]">
        <div className="relative order-2 lg:order-1 overflow-hidden min-h-[50vh] lg:min-h-full">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1653984/img/LS_Home_Composite-decking_04-1.webp" className="w-full h-auto object-cover absolute inset-0 w-full h-full" alt="Composite Decking" />
          <div className="absolute inset-0 bg-gradient-to-r from-background/60 via-background/20 to-transparent lg:hidden" />
          <div className="absolute bottom-6 left-6 lg:hidden">
            <span className="text-xs tracking-[0.35em] uppercase text-white/70 font-light" style={{
            fontFamily: "'Space Grotesk', sans-serif"
          }}>
              #where beautiful gardens begin
            </span>
          </div>
        </div>

        <div className="order-1 lg:order-2 flex flex-col justify-center bg-black px-8 py-16 lg:px-16 xl:px-24 relative">
          <div ref={contentRef} className="opacity-0 translate-y-8 transition-all duration-700 ease-out max-w-lg">
            <div className="flex items-center gap-3 mb-8">
              <div className="h-px w-10 bg-[#89b394]/70" />
              <span className="text-xs tracking-[0.3em] uppercase text-[#89b394] font-medium" style={{
              fontFamily: "'Space Grotesk', sans-serif"
            }}>Clear, efficient, and stress-free<br /></span>
            </div>

            <h2 className="text-5xl xl:text-6xl font-bold text-foreground leading-tight mb-6" style={{
            fontFamily: "'Playfair Display', serif"
          }}>Our<br /><em className="font-normal italic text-[#89b394]/90" data-ast-id="f:/src/pages/Home/sections/CompositeDeckingFeature.tsx|sig:hvox10" data-ast-start="2754" data-ast-end="2819">Process</em></h2>

            <div className="h-px w-full bg-border my-8 opacity-40" />

            <p className="text-muted-foreground text-base lg:text-lg leading-relaxed font-light mb-10" style={{
            fontFamily: "'Space Grotesk', sans-serif"
          }}><div>Clear, efficient, and stress-free from start to finish.</div><div><br />Free Consultation — We discuss your ideas, assess your space, and provide a no-obligation quote.</div><div><br />Planning &amp; Design — We create a practical plan tailored to your space, covering layout, materials, and details.</div><div><br />Installation — Our team works with care, keeping the site tidy and completing everything to a high standard.</div><div><br />Final Walkthrough — We review the finished work with you and leave your space clean and ready.</div></p>

            <QuoteButton className="group" style={{
            fontFamily: "'Space Grotesk', sans-serif"
          }}>
              Get a free quote<span className="ml-3 inline-block transition-transform duration-300 group-hover:translate-x-1" data-ast-id="f:/src/pages/Home/sections/CompositeDeckingFeature.tsx|sig:l2msru" data-ast-start="4129" data-ast-end="4274"></span>
            </QuoteButton>

            
          </div>
        </div>
      </div>
    </section>;
}